import Vue from 'vue'

import {
  STRIPE_API_ENDPOINTS,
} from '../../lib/url'

export default {
  loadUserStripe ({dispatch, commit, getters}, user) {

    if (!user.customer_id) {
      commit('setStripeCustomerLoading', true)
      return dispatch('createStripeCustomer', {
        email: user.email,
        name: user.name
      }).then(({customer: stripeCustomer}) => {
        user.customer_id = stripeCustomer.id
        dispatch('updateUser', user)
        // commit('setStripeCustomer', stripeCustomer)
        // commit('setStripeCustomerLoading', false)
        return dispatch('loadUserStripe', user)
      })
    }

    if (!user.subscription_id) {
      commit('setStripeSubscriptionLoading', true)
      const plan_name = 'developer'
      return dispatch('createStripeSubscription', {
        customer_id: user.customer_id,
        plan_name
      }).then(({subscription: stripeSubscription}) => {
        user.subscription_id = stripeSubscription.id
        user.subscription_plan = plan_name
        dispatch('updateUser', user)
        commit('setStripeSubscription', stripeSubscription)
        commit('setStripeSubscriptionLoading', false)
        return dispatch('loadUserStripe', user)
      })
    }

    // if (getters.stripeCardsHasMore) {
    //   console.log('gonna fetch cards history')
    //   const lastCard = getters.stripeCards[getters.stripeCards.length - 1]
    //   dispatch('getStripeCardsList', {
    //     customer_id: user.customer_id,
    //     starting_after: lastCard && lastCard.id || undefined
    //   }).then(({cards: stripeCards}) => {
    //     console.log(stripeCards)
    //     commit('addStripeCards', stripeCards)
    //   })
    // }

    if (!getters.stripeCustomer) {
      commit('setStripeCustomerLoading', true)
      dispatch('getStripeCustomer', {
        customer_id: user.customer_id
      }).then(({customer: stripeCustomer}) => {
        commit('setStripeCustomer', stripeCustomer)
        commit('setStripeCustomerLoading', false)
        if (stripeCustomer.default_source) {
          const cardFromSources = stripeCustomer.sources.data.filter((c) => c.type != 'ach_credit_transfer').find((c) => c.id === stripeCustomer.default_source)
          if (!cardFromSources) {
            commit('setStripeCardLoading', true)
            dispatch('getStripeCard', {
              customer_id: user.customer_id,
              card_id: stripeCustomer.default_source
            }).then(({card: stripeCard}) => {
              commit('setStripeCard', stripeCard)
            }).finally(() => {
              commit('setStripeCardLoading', false)
            })
          } else {
            commit('setStripeCard', cardFromSources)
            commit('setStripeCardLoading', false)
          }
        } else {
          commit('setStripeCard', null)
          commit('setStripeCardLoading', false)
        }
      })
    }

    if (!getters.stripeSubscription) {
      commit('setStripeSubscriptionLoading', true)
      dispatch('getStripeSubscription', {
        subscription_id: user.subscription_id
      }).then(({subscription: stripeSubscription}) => {
        commit('setStripeSubscription', stripeSubscription)
        commit('setStripeSubscriptionLoading', false)
      })
    }

    if (getters.stripeInvoicesHasMore) {
      dispatch('loadMoreStripeInvoices', user)
    }

    return Promise.resolve(user)

  },

  // downgradeStripeSubscription ({dispatch, commit}, payload) {
  //   return new Promise((resolve, reject) => {
  //     commit('setStripeSubscriptionLoading', true)
  //     dispatch('updateStripeSubscription', payload)
  //     .then(({subscription: stripeSubscription}) => {
  //       commit('setStripeSubscription', stripeSubscription)
  //       commit('setStripeSubscriptionLoading', false)
  //       resolve(stripeSubscription)
  //       dispatch('updateUser', {
  //         subscription_id: stripeSubscription.id,
  //         subscription_plan: 'developer',
  //         usage: {
  //           current: 0,
  //         },
  //       })
  //       dispatch('loadNewStripeInvoices')
  //     })
  //     .catch((err) => reject(err))
  //   })
  // },
  // upgradeStripeSubscription ({dispatch, commit}, payload) {
  //   return new Promise((resolve, reject) => {
  //     commit('setStripeSubscriptionLoading', true)
  //     dispatch('updateStripeSubscription', payload)
  //     .then(({subscription: stripeSubscription}) => {
  //       commit('setStripeSubscription', stripeSubscription)
  //       commit('setStripeSubscriptionLoading', false)
  //       resolve(stripeSubscription)
  //       dispatch('updateUser', {
  //         subscription_id: stripeSubscription.id,
  //         subscription_plan: 'business',
  //         usage: {
  //           current: 0,
  //         },
  //       })
  //       dispatch('loadNewStripeInvoices')
  //     })
  //     .catch((err) => reject(err))
  //   })
  // },
  updateSubscription ({dispatch, commit}, payload) {
    return new Promise((resolve, reject) => {
      commit('setStripeSubscriptionLoading', true)
      dispatch('updateStripeSubscription', payload)
      .then(({subscription: stripeSubscription}) => {
        commit('setStripeSubscription', stripeSubscription)
        commit('setStripeSubscriptionLoading', false)
        resolve(stripeSubscription)
        dispatch('updateUser', {
          subscription_id: stripeSubscription.id,
          subscription_plan: payload.targetPlan,
          usage: {
            current: 0,
          },
        })
        // dispatch('updateApiUsage', payload)
        dispatch('loadNewStripeInvoices')
      })
      .catch((err) => reject(err))
    })
  },

  loadMoreStripeInvoices ({dispatch, commit, getters}, user) {
    commit('setStripeInvoicesLoading', true)
    const lastInvoice = getters.stripeInvoices[getters.stripeInvoices.length - 1]
    return new Promise((resolve, reject) => {
      dispatch('getStripeInvoicesList', {
        customer_id: getters.user.customer_id || user.customer_id,
        limit: 10,
        starting_after: lastInvoice && lastInvoice.id || undefined
      }).then(({invoices: stripeInvoices}) => {
        commit('appendStripeInvoices', stripeInvoices)
        commit('setStripeInvoicesLoading', false)
        resolve()
      }).catch((err) => reject(err))
    })
  },
  loadNewStripeInvoices ({dispatch, commit, getters}) {
    commit('setStripeInvoicesLoading', true)
    const firstInvoice = getters.stripeInvoices[0]
    return new Promise((resolve, reject) => {
      dispatch('getStripeInvoicesList', {
        customer_id: getters.user.customer_id,
        limit: 10,
        ending_before: firstInvoice && firstInvoice.id || undefined
      }).then(({invoices: stripeInvoices}) => {
        commit('prependStripeInvoices', stripeInvoices)
        commit('setStripeInvoicesLoading', false)
        resolve()
      }).catch((err) => reject(err))
    })
  },

  createStripeCustomer ({commit}, payload) {
    const headers = {}
    if (process.env.VUE_APP_ENV !== 'production') {
      headers['Accept'] = 'application/vnd.quickreceipts.v0+json';
    }
    return new Promise((resolve, reject) => Vue.http.post(STRIPE_API_ENDPOINTS.CUSTOMER_CREATE, payload, {headers}).then((response) => resolve(response.body)).catch((response) => reject(response.body)))
  },
  getStripeCustomer ({commit}, payload) {
    const headers = {}
    if (process.env.VUE_APP_ENV !== 'production') {
      headers['Accept'] = 'application/vnd.quickreceipts.v0+json';
    }
    return new Promise((resolve, reject) => Vue.http.post(STRIPE_API_ENDPOINTS.CUSTOMER_GET, payload, {headers}).then((response) => resolve(response.body)).catch((response) => reject(response.body)))
  },

  createStripeSubscription ({commit}, payload) {
    const headers = {}
    if (process.env.VUE_APP_ENV !== 'production') {
      headers['Accept'] = 'application/vnd.quickreceipts.v0+json';
    }
    return new Promise((resolve, reject) => Vue.http.post(STRIPE_API_ENDPOINTS.SUBSCRIPTION_CREATE, payload, {headers}).then((response) => resolve(response.body)).catch((response) => reject(response.body)))
  },
  getStripeSubscription ({commit}, payload) {
    const headers = {}
    if (process.env.VUE_APP_ENV !== 'production') {
      headers['Accept'] = 'application/vnd.quickreceipts.v0+json';
    }
    return new Promise((resolve, reject) => Vue.http.post(STRIPE_API_ENDPOINTS.SUBSCRIPTION_GET, payload, {headers}).then((response) => resolve(response.body)).catch((response) => reject(response.body)))
  },
  updateStripeSubscription ({commit}, payload) {
    const headers = {}
    if (process.env.VUE_APP_ENV !== 'production') {
      headers['Accept'] = 'application/vnd.quickreceipts.v0+json';
    }
    return new Promise((resolve, reject) => Vue.http.post(STRIPE_API_ENDPOINTS.SUBSCRIPTION_UPDATE, payload, {headers}).then((response) => resolve(response.body)).catch((response) => reject(response.body)))
  },

  getStripeCardsList ({commit}, payload) {
    const headers = {}
    if (process.env.VUE_APP_ENV !== 'production') {
      headers['Accept'] = 'application/vnd.quickreceipts.v0+json';
    }
    return new Promise((resolve, reject) => Vue.http.post(STRIPE_API_ENDPOINTS.CARDS_LIST, payload, {headers}).then((response) => resolve(response.body)).catch((response) => reject(response.body)))
  },
  getStripeCard ({commit}, payload) {
    const headers = {}
    if (process.env.VUE_APP_ENV !== 'production') {
      headers['Accept'] = 'application/vnd.quickreceipts.v0+json';
    }
    return new Promise((resolve, reject) => Vue.http.post(STRIPE_API_ENDPOINTS.CARD_GET, payload, {headers}).then((response) => resolve(response.body)).catch((response) => reject(response.body)))
  },
  submitStripeCard ({commit}, payload) {
    const headers = {}
    if (process.env.VUE_APP_ENV !== 'production') {
      headers['Accept'] = 'application/vnd.quickreceipts.v0+json';
    }
    return new Promise((resolve, reject) => Vue.http.post(STRIPE_API_ENDPOINTS.CARD_SUBMIT, payload, {headers}).then((response) => resolve(response.body)).catch((response) => reject(response.body)))
  },

  getStripeInvoicesList ({commit}, payload) {
    const headers = {}
    if (process.env.VUE_APP_ENV !== 'production') {
      headers['Accept'] = 'application/vnd.quickreceipts.v0+json';
    }
    return new Promise((resolve, reject) => Vue.http.post(STRIPE_API_ENDPOINTS.INVOICES_LIST, payload, {headers}).then((response) => resolve(response.body)).catch((response) => reject(response.body)))
  }
}
